import { Reducer } from 'react';
import { Action as DefaultAction } from 'state/types';

export enum ActionTypes {
  SET = 'SET',
}

export type AvailableLogin = {
  first_name: string;
  last_name: string;
  uuid: string;
};

type User = Partial<{
  available_logins: AvailableLogin[];
  avatar: string | null;
  clinical_role: {
    description: string;
    id: number;
    name: string;
  };
  first_name: string;
  id: number;
  uuid: string;
  last_name: string;
  original_user: {
    available_logins: AvailableLogin[];
    first_name: string;
    last_name: string;
    uuid: string;
  };
}>;

export type State = User & { auth_token?: string; isOriginalUser?: boolean };

type Payload = {
  [ActionTypes.SET]: User & { isOriginalUser?: boolean };
};

export type Action = DefaultAction<Payload>;

export const initialState: State = {};

export const reducer: Reducer<State, Action> = (state: State = initialState, action: Action) => {
  switch (action.type) {
    case ActionTypes.SET: {
      const { payload } = action;
      return {
        ...state,
        ...payload,
      };
    }

    default:
      throw new Error('Unexpected action');
  }
};
